import { Divider, Space } from "antd";

const Headline = ({children}) => {
  return (
    <Space direction='vertical' size={20} style={{width: '100%'}}>
      <h2>{children}</h2>
      <Divider style={{margin: 0, borderBlockStart: '1px solid rgba(88, 66, 113, 1)'}} />
    </Space>
  )
}

export default Headline;
